export default class CookiePolicy {
    constructor(container) {
        this.container = container;
        this.initScrollY = 0;
        this.scrollToHideLength = 100;
    }

    showMessage() {
        this.container.removeClass('hidden');
        localStorage.cookiePolicy = false;
    }

    hideMessage() {
        this.container.addClass('hidden');
        return false;
    }

    setListeners() {
        $(window).on('scroll.cookie-policy', () => {
            if (Math.abs(this.initScrollY - window.scrollY) > this.scrollToHideLength) {
                this.hideMessage();
            }
        });

        this.container.find('[data-cookie-policy-close]')
            .on('click.cookie-policy-close', '', $.proxy(this, 'hideMessage'));
    }

    init() {
        this.initScrollY = window.scrollY;

        try {
            if (typeof localStorage.cookiePolicy === 'undefined') {
                localStorage.cookiePolicy = true;
            }

            if (JSON.parse(localStorage.cookiePolicy)) {
                this.setListeners();
                this.showMessage();
            } else {
                this.hideMessage();
            }
        } catch(e) {
            this.hideMessage();
        }
    }
}
